// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/background_campana_baloers.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-baloers{    
    width: 100%;
}
.campaign-baloers__banner{
    max-width: 1440px;
    height: 376px;
    margin: 0 auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;   
    padding-top: 97px;
}
.campaign-baloers__banner-text-intro{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 47px;
    color: var(--white-color);
    margin: 0 auto;
    width: 340px;
    text-align: center;
    text-transform: uppercase;
}
.campaign-baloers__banner-text-prizes{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 900;
    font-size: 50px;
    line-height: 59px;
    color: var(--white-color);
    margin: 0 auto;
    background: var(--new-green-color);
    width: 585px;
    text-align: center;
    padding: 12px;
    text-transform: uppercase;
}
.campaign-baloers__banner-text-winners{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 500;
    font-size: 35px;
    line-height: 41px;
    color: var(--white-color);
    margin: 0 auto;
    width: 370px;
    text-align: center;
    text-transform: uppercase;
}
.campaign-baloers__banner-apps{
    position: absolute;
    top: 212px;
    right: 20%;
}

.campaign-baloers__banner__gplay-icon{
    position: absolute;

}
.campaign-baloers__banner__appstore-icon{
    position: absolute;
    margin-top: 50px;

}

.campaign-baloers__how-to{
    max-width: 1440px;
    margin: 0 auto;
    padding-top: 78px;
    padding-left: 160px;
    padding-right: 160px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.campaign-baloers__text-intro{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 900;
    font-size: 36px;
    line-height: 42px;
    color: var(--primary-very-dark-color);
    text-transform: uppercase;
    width: 100%;
    margin-bottom: 18px;
}
.campaign-baloers__how-to__intro{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-dark-color);
    width: 584px;
    height: 210px;
    border-radius: 10px;
    padding: 20px;
    background: var(--white-color);
}
.campaign-baloers__how-to__message{
    padding-top: 24px;
}
.campaign-baloers__how-to__green-message{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    text-align: center;
    width: 445px;
    height: 70px;
    color: var(--white-color);
    background: var(--new-green-color);
    border-radius: 10px;
    padding: 14px;
    margin-bottom: 8px;
}
.campaign-baloers__how-to__callto{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 21px;
    color: var(--primary-very-dark-color);
    width: 250px;
    margin: 0 auto;
    text-align: center;
    text-transform: uppercase;
}
.campaign-baloers__prizes{
    max-width: 1440px;
    margin: 0 auto;
    padding-top: 40px;
    padding-left: 160px;
    padding-right: 160px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.campaign-baloers__prizes-table{

}
.campaign-baloers__prizes__table{
    border-radius: 10px;
    background: var(--white-color);
    border-collapse: collapse;
    width: 424px;
}

.campaign-baloers__prizes__table td{
    border-bottom: 1px solid var(--new-gray-background-color);
    width: 50%;
    padding: 8px 12px;
}
.campaign-baloers__prizes__column-prize{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: var(--new-green-color);   
}
.campaign-baloers__prizes__column-prize-desc{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-very-dark-color);
}
.campaign-baloers__prizes-measurement{
    width: 671px;
    height: 118px;
    border-radius: 10px;
    padding: 10px 20px;
    background: var(--white-color);
    margin-top: 8px;
}
.campaign-baloers__prizes-measurement-title{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 21px;
    color: var(--primary-very-dark-color);
}
.campaign-baloers__prizes-measurement-text{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    color: var(--primary-dark-color);
    padding-top: 14px;
}
.campaign-baloers__example{
    max-width: 1440px;
    margin: 0 auto;
    padding-top: 32px;
    padding-left: 160px;
    padding-right: 160px;
}
.campaign-baloers__example-title{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: var(--primary-dark-color);
    padding-top: 16px;
}
.campaign-baloers__example-table{
    margin-top: 16px;
}
.campaign-baloers__example__table{
    border-radius: 10px;
    background: var(--white-color);
    border-collapse: collapse;
    width: 100%;
}
.campaign-baloers__example__table td{
    border-bottom: 1px solid var(--new-gray-background-color);
    width: 20%;
    padding: 8px 12px;
}
.campaign-baloers__example__column-header{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: var(--new-green-color);
}
.campaign-baloers__example__column-text{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-very-dark-color);
}
.campaign-baloers__example__column-lbl{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-very-dark-color);
}
.campaign-baloers__definitions{
    max-width: 1440px;
    margin: 0 auto;
    padding-top: 40px;
    padding-left: 160px;
    padding-right: 160px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.campaign-baloers__definitions-image{
    padding-left: 27px;
    padding-right: 16px;
}
.campaign-baloers__definitions-baloers{
    width: 392px;
    height: 266px;
    background: var(--white-color);
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 109px;
}
.campaign-baloers__definitions-baloers .iconbal-Balores{
    font-size: 42px;
}
.campaign-baloers__definitions-verified{
    width: 392px;
    height: 266px;
    background: var(--white-color);
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 109px;
}
.campaign-baloers__definitions-verified .iconb2-Verificated{
    font-size: 42px;
}
.campaign-baloers__definitions-title{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 900;
    font-size: 25px;
    line-height: 29px;
    text-align: center;
    text-transform: uppercase;
    color: var(--new-green-color);
    margin-top: 13px;
}
.campaign-baloers__definitions-text{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-dark-color);
    margin-top: 13px;
}
.campaign-baloers__howto-apply{
    max-width: 1440px;
    margin: 0 auto;
    padding-top: 40px;
    padding-left: 160px;
    padding-right: 160px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.campaign-baloers__howto-apply-steps{
    width: 673px;
    height: 352px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background: var(--white-color);
    border-radius: 10px;
    margin-top: 20px;
    margin-left: 85px;
}
.campaign-baloers__howto-apply-steps__title{

}
.campaign-baloers__howto-apply-steps__steps{
    margin-top: 26px;   
}
.campaign-baloers__howto-apply-steps__number{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 21px;
    color: var(--new-green-color);
    padding-right: 16px;
}
.campaign-baloers__howto-apply-steps__steps-step{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-dark-color);
    margin-bottom: 16px;
}
.campaign-baloers__howto-apply-steps__apps-images img{
    margin-right: 8px;
}
.campaign-baloers__howto-apply-image{
    margin-right: 84px;
}
.campaign-baloers__termsandconditions{
    max-width: 1440px;
    margin: 0 auto;
    padding-top: 50px;
    padding-left: 160px;
    padding-right: 160px;
}
.campaign-baloers__termsandconditions_container{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 20px;
    background: var(--white-color);
    border-radius: 10px;
}
.campaign-baloers__termsandconditions-title{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    text-transform: uppercase;
    color: var(--primary-very-dark-color);
}
.campaign-baloers__termsandconditions__tyc{
    margin-top: 32px;
}
.campaign-baloers__termsandconditions__tyc__terms{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary-dark-color);
    margin-bottom: 16px;
}
.campaign-baloers__footer{
    max-width: 1440px;
    height: 151px;
    margin: 0 auto;
    padding-top: 43px;
    background: var(--primary-very-dark-color);
    margin-top: 97px;
    padding-left: 33px;
}
.campaign-baloers__footer-logo{

}
.campaign-baloers__footer-text{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: var(--white-color);
    text-transform: uppercase;
    margin-top: 20px;
}
@media only screen and (max-width: 1440px) {
    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, 
    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{
        padding-left: 100px;
        padding-right: 100px;
    }
}
@media only screen and (max-width: 1300px) {
    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, 
    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{
        padding-left: 60px;
        padding-right: 60px;
    }
}
@media only screen and (max-width: 1220px) {
    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, 
    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{
        padding-left: 40px;
        padding-right: 40px;
    }
}
@media only screen and (max-width: 1180px) {
    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, 
    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{
        padding-left: 20px;
        padding-right: 20px;
    }
    .campaign-baloers__how-to__intro{
        width: 50%;
        height: auto;
    }

    .campaign-baloers__prizes-measurement {
        width: 50%;
        height: 145px;
    }

    .campaign-baloers__definitions-baloers{
        width: 320px;
        height: 288px;
    }
    .campaign-baloers__definitions-verified{
        width: 320px;
        height: 288px;
    }
    .campaign-baloers__howto-apply-steps{
        margin-left: unset;
    }
    .campaign-baloers__howto-apply-image{
        margin-right: unset;
    }
}
@media only screen and (max-width: 980px) {
    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, 
    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{
        padding-left: 10px;
        padding-right: 10px;
    }
    .campaign-baloers__how-to__intro{
        width: unset;
        height: auto;
    }
    .campaign-baloers__how-to__message{
        margin: 0 auto;
    }
    .campaign-baloers__prizes-measurement {       
        height: 145px;
    }

    .campaign-baloers__definitions-baloers{
        width: 280px;
        height: 328px;
        margin-top: 70px;
    }
    .campaign-baloers__definitions-verified{
        width: 280px;
        height: 328px;
        margin-top: 70px;
    }
    .campaign-baloers__howto-apply-steps{
        margin-left: unset;
        width: 100%;
    }
    .campaign-baloers__howto-apply-image{
        margin-right: unset;
        margin: 0 auto;
    }
}
@media only screen and (max-width: 870px) {/* Iphone 11*/
    .campaign-baloers__banner-text-prizes{
        width: 480px;
    }
    .campaign-baloers__definitions-baloers{
        width: 240px;
        height: 386px;
        margin-top: 40px;
    }
    .campaign-baloers__definitions-verified{
        width: 240px;
        height: 386px;
        margin-top: 40px;
    }
    .campaign-baloers__prizes-measurement {       
        width: 100%;
    }
    
}
@media only screen and (max-width: 770px) {
    .campaign-baloers__banner-text-intro{
        font-size: 30px;
        line-height: 37px;
        width: unset;
    }
    .campaign-baloers__banner-text-prizes{
        font-size: 40px;
        line-height: 49px;
        width: unset;
    }
    .campaign-baloers__banner-text-winners{
        font-size: 25px;
        line-height: 21px;
        width: unset;
    }
    .campaign-baloers__banner-apps {
        top: 380px;
        right: 60%;
    }
    .campaign-baloers__how-to__intro{
        height: auto;
    }
  
/*     .campaign-baloers__definitions-baloers{
        height: auto;
    }
    .campaign-baloers__definitions-verified{
        height: auto;
    } */
    .campaign-baloers__howto-apply-steps{
        margin-left: 0;
        height: auto;
    }
    .campaign-baloers__prizes__table{
        width: auto;
    }
    .campaign-baloers__prizes-measurement{
        height: auto;
    }

}

@media only screen and (max-width: 420px) {
    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, 
    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{
        padding-left: 0;
        padding-right: 0;
    }
    .campaign-baloers__banner-text-intro{
        font-size: 30px;
        line-height: 37px;
        width: unset;
    }
    .campaign-baloers__banner-text-prizes{
        font-size: 40px;
        line-height: 49px;
        width: unset;
    }
    .campaign-baloers__banner-text-winners{
        font-size: 25px;
        line-height: 21px;
        width: unset;
    }

    .campaign-baloers__banner-apps {
        top: 412px;
        right: 70%;
    }
    .campaign-baloers__how-to__intro{
        height: auto;
    }
    .campaign-baloers__how-to__green-message{
        width: unset;
        height: auto;
    }

    .campaign-baloers__definitions-baloers{
        width: 100%;
        height: auto;
    }
    .campaign-baloers__definitions-verified{
        width: 100%;
        height: auto;
    }
    .campaign-baloers__howto-apply-steps{
        margin-left: 0;
        height: auto;
    }
    .campaign-baloers__prizes__table{
        width: auto;
    }
    .campaign-baloers__prizes-measurement{
        height: auto;
    }
    .campaign-baloers__example__table td{
        padding: 8px 8px;
    }
    .campaign-baloers__example__column-header, .campaign-baloers__example__column-lbl, 
    .campaign-baloers__example__column-text{
        font-size: 12px;
        line-height: 15px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/app/campaigns/views/CampaignBaloersView.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,yDAA8E;IAC9E,4BAA4B;IAC5B,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,kCAAkC;IAClC,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;;AAEtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;IACrC,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;AACA;;AAEA;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yDAAyD;IACzD,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yDAAyD;IACzD,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;AAEA;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,qCAAqC;AACzC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;AACtB;AACA;;AAEA;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI;;QAEI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;AACA;IACI;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;IACA;QACI,YAAY;QACZ,aAAa;IACjB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;;QAEI,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,mBAAmB;QACnB,cAAc;IAClB;AACJ;AACA,2CAA2C,aAAa;IACpD;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,WAAW;IACf;;AAEJ;AACA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;IAChB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;IAChB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;IAChB;IACA;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,YAAY;IAChB;;AAEJ;;;;;OAKO;IACH;QACI,cAAc;QACd,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;IAChB;;AAEJ;;AAEA;IACI;;QAEI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;IAChB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;IAChB;IACA;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,cAAc;QACd,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;IAChB;IACA;QACI,gBAAgB;IACpB;IACA;;QAEI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".campaign-baloers{    \n    width: 100%;\n}\n.campaign-baloers__banner{\n    max-width: 1440px;\n    height: 376px;\n    margin: 0 auto;\n    background-image: url(\"../../../assets/images/background_campana_baloers.png\");\n    background-repeat: no-repeat;\n    background-position: center;   \n    padding-top: 97px;\n}\n.campaign-baloers__banner-text-intro{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: bold;\n    font-size: 40px;\n    line-height: 47px;\n    color: var(--white-color);\n    margin: 0 auto;\n    width: 340px;\n    text-align: center;\n    text-transform: uppercase;\n}\n.campaign-baloers__banner-text-prizes{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 900;\n    font-size: 50px;\n    line-height: 59px;\n    color: var(--white-color);\n    margin: 0 auto;\n    background: var(--new-green-color);\n    width: 585px;\n    text-align: center;\n    padding: 12px;\n    text-transform: uppercase;\n}\n.campaign-baloers__banner-text-winners{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 35px;\n    line-height: 41px;\n    color: var(--white-color);\n    margin: 0 auto;\n    width: 370px;\n    text-align: center;\n    text-transform: uppercase;\n}\n.campaign-baloers__banner-apps{\n    position: absolute;\n    top: 212px;\n    right: 20%;\n}\n\n.campaign-baloers__banner__gplay-icon{\n    position: absolute;\n\n}\n.campaign-baloers__banner__appstore-icon{\n    position: absolute;\n    margin-top: 50px;\n\n}\n\n.campaign-baloers__how-to{\n    max-width: 1440px;\n    margin: 0 auto;\n    padding-top: 78px;\n    padding-left: 160px;\n    padding-right: 160px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.campaign-baloers__text-intro{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 900;\n    font-size: 36px;\n    line-height: 42px;\n    color: var(--primary-very-dark-color);\n    text-transform: uppercase;\n    width: 100%;\n    margin-bottom: 18px;\n}\n.campaign-baloers__how-to__intro{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--primary-dark-color);\n    width: 584px;\n    height: 210px;\n    border-radius: 10px;\n    padding: 20px;\n    background: var(--white-color);\n}\n.campaign-baloers__how-to__message{\n    padding-top: 24px;\n}\n.campaign-baloers__how-to__green-message{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 21px;\n    text-align: center;\n    width: 445px;\n    height: 70px;\n    color: var(--white-color);\n    background: var(--new-green-color);\n    border-radius: 10px;\n    padding: 14px;\n    margin-bottom: 8px;\n}\n.campaign-baloers__how-to__callto{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 900;\n    font-size: 18px;\n    line-height: 21px;\n    color: var(--primary-very-dark-color);\n    width: 250px;\n    margin: 0 auto;\n    text-align: center;\n    text-transform: uppercase;\n}\n.campaign-baloers__prizes{\n    max-width: 1440px;\n    margin: 0 auto;\n    padding-top: 40px;\n    padding-left: 160px;\n    padding-right: 160px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.campaign-baloers__prizes-table{\n\n}\n.campaign-baloers__prizes__table{\n    border-radius: 10px;\n    background: var(--white-color);\n    border-collapse: collapse;\n    width: 424px;\n}\n\n.campaign-baloers__prizes__table td{\n    border-bottom: 1px solid var(--new-gray-background-color);\n    width: 50%;\n    padding: 8px 12px;\n}\n.campaign-baloers__prizes__column-prize{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--new-green-color);   \n}\n.campaign-baloers__prizes__column-prize-desc{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--primary-very-dark-color);\n}\n.campaign-baloers__prizes-measurement{\n    width: 671px;\n    height: 118px;\n    border-radius: 10px;\n    padding: 10px 20px;\n    background: var(--white-color);\n    margin-top: 8px;\n}\n.campaign-baloers__prizes-measurement-title{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 900;\n    font-size: 18px;\n    line-height: 21px;\n    color: var(--primary-very-dark-color);\n}\n.campaign-baloers__prizes-measurement-text{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 18px;\n    line-height: 21px;\n    color: var(--primary-dark-color);\n    padding-top: 14px;\n}\n.campaign-baloers__example{\n    max-width: 1440px;\n    margin: 0 auto;\n    padding-top: 32px;\n    padding-left: 160px;\n    padding-right: 160px;\n}\n.campaign-baloers__example-title{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: bold;\n    font-size: 18px;\n    line-height: 21px;\n    color: var(--primary-dark-color);\n    padding-top: 16px;\n}\n.campaign-baloers__example-table{\n    margin-top: 16px;\n}\n.campaign-baloers__example__table{\n    border-radius: 10px;\n    background: var(--white-color);\n    border-collapse: collapse;\n    width: 100%;\n}\n.campaign-baloers__example__table td{\n    border-bottom: 1px solid var(--new-gray-background-color);\n    width: 20%;\n    padding: 8px 12px;\n}\n.campaign-baloers__example__column-header{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--new-green-color);\n}\n.campaign-baloers__example__column-text{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--primary-very-dark-color);\n}\n.campaign-baloers__example__column-lbl{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--primary-very-dark-color);\n}\n.campaign-baloers__definitions{\n    max-width: 1440px;\n    margin: 0 auto;\n    padding-top: 40px;\n    padding-left: 160px;\n    padding-right: 160px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.campaign-baloers__definitions-image{\n    padding-left: 27px;\n    padding-right: 16px;\n}\n.campaign-baloers__definitions-baloers{\n    width: 392px;\n    height: 266px;\n    background: var(--white-color);\n    border-radius: 10px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 109px;\n}\n.campaign-baloers__definitions-baloers .iconbal-Balores{\n    font-size: 42px;\n}\n.campaign-baloers__definitions-verified{\n    width: 392px;\n    height: 266px;\n    background: var(--white-color);\n    border-radius: 10px;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 109px;\n}\n.campaign-baloers__definitions-verified .iconb2-Verificated{\n    font-size: 42px;\n}\n.campaign-baloers__definitions-title{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 900;\n    font-size: 25px;\n    line-height: 29px;\n    text-align: center;\n    text-transform: uppercase;\n    color: var(--new-green-color);\n    margin-top: 13px;\n}\n.campaign-baloers__definitions-text{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--primary-dark-color);\n    margin-top: 13px;\n}\n.campaign-baloers__howto-apply{\n    max-width: 1440px;\n    margin: 0 auto;\n    padding-top: 40px;\n    padding-left: 160px;\n    padding-right: 160px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n}\n.campaign-baloers__howto-apply-steps{\n    width: 673px;\n    height: 352px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    background: var(--white-color);\n    border-radius: 10px;\n    margin-top: 20px;\n    margin-left: 85px;\n}\n.campaign-baloers__howto-apply-steps__title{\n\n}\n.campaign-baloers__howto-apply-steps__steps{\n    margin-top: 26px;   \n}\n.campaign-baloers__howto-apply-steps__number{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 900;\n    font-size: 18px;\n    line-height: 21px;\n    color: var(--new-green-color);\n    padding-right: 16px;\n}\n.campaign-baloers__howto-apply-steps__steps-step{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--primary-dark-color);\n    margin-bottom: 16px;\n}\n.campaign-baloers__howto-apply-steps__apps-images img{\n    margin-right: 8px;\n}\n.campaign-baloers__howto-apply-image{\n    margin-right: 84px;\n}\n.campaign-baloers__termsandconditions{\n    max-width: 1440px;\n    margin: 0 auto;\n    padding-top: 50px;\n    padding-left: 160px;\n    padding-right: 160px;\n}\n.campaign-baloers__termsandconditions_container{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 20px;\n    background: var(--white-color);\n    border-radius: 10px;\n}\n.campaign-baloers__termsandconditions-title{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 21px;\n    text-transform: uppercase;\n    color: var(--primary-very-dark-color);\n}\n.campaign-baloers__termsandconditions__tyc{\n    margin-top: 32px;\n}\n.campaign-baloers__termsandconditions__tyc__terms{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 19px;\n    color: var(--primary-dark-color);\n    margin-bottom: 16px;\n}\n.campaign-baloers__footer{\n    max-width: 1440px;\n    height: 151px;\n    margin: 0 auto;\n    padding-top: 43px;\n    background: var(--primary-very-dark-color);\n    margin-top: 97px;\n    padding-left: 33px;\n}\n.campaign-baloers__footer-logo{\n\n}\n.campaign-baloers__footer-text{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 16px;\n    color: var(--white-color);\n    text-transform: uppercase;\n    margin-top: 20px;\n}\n@media only screen and (max-width: 1440px) {\n    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, \n    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{\n        padding-left: 100px;\n        padding-right: 100px;\n    }\n}\n@media only screen and (max-width: 1300px) {\n    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, \n    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{\n        padding-left: 60px;\n        padding-right: 60px;\n    }\n}\n@media only screen and (max-width: 1220px) {\n    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, \n    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{\n        padding-left: 40px;\n        padding-right: 40px;\n    }\n}\n@media only screen and (max-width: 1180px) {\n    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, \n    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n    .campaign-baloers__how-to__intro{\n        width: 50%;\n        height: auto;\n    }\n\n    .campaign-baloers__prizes-measurement {\n        width: 50%;\n        height: 145px;\n    }\n\n    .campaign-baloers__definitions-baloers{\n        width: 320px;\n        height: 288px;\n    }\n    .campaign-baloers__definitions-verified{\n        width: 320px;\n        height: 288px;\n    }\n    .campaign-baloers__howto-apply-steps{\n        margin-left: unset;\n    }\n    .campaign-baloers__howto-apply-image{\n        margin-right: unset;\n    }\n}\n@media only screen and (max-width: 980px) {\n    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, \n    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{\n        padding-left: 10px;\n        padding-right: 10px;\n    }\n    .campaign-baloers__how-to__intro{\n        width: unset;\n        height: auto;\n    }\n    .campaign-baloers__how-to__message{\n        margin: 0 auto;\n    }\n    .campaign-baloers__prizes-measurement {       \n        height: 145px;\n    }\n\n    .campaign-baloers__definitions-baloers{\n        width: 280px;\n        height: 328px;\n        margin-top: 70px;\n    }\n    .campaign-baloers__definitions-verified{\n        width: 280px;\n        height: 328px;\n        margin-top: 70px;\n    }\n    .campaign-baloers__howto-apply-steps{\n        margin-left: unset;\n        width: 100%;\n    }\n    .campaign-baloers__howto-apply-image{\n        margin-right: unset;\n        margin: 0 auto;\n    }\n}\n@media only screen and (max-width: 870px) {/* Iphone 11*/\n    .campaign-baloers__banner-text-prizes{\n        width: 480px;\n    }\n    .campaign-baloers__definitions-baloers{\n        width: 240px;\n        height: 386px;\n        margin-top: 40px;\n    }\n    .campaign-baloers__definitions-verified{\n        width: 240px;\n        height: 386px;\n        margin-top: 40px;\n    }\n    .campaign-baloers__prizes-measurement {       \n        width: 100%;\n    }\n    \n}\n@media only screen and (max-width: 770px) {\n    .campaign-baloers__banner-text-intro{\n        font-size: 30px;\n        line-height: 37px;\n        width: unset;\n    }\n    .campaign-baloers__banner-text-prizes{\n        font-size: 40px;\n        line-height: 49px;\n        width: unset;\n    }\n    .campaign-baloers__banner-text-winners{\n        font-size: 25px;\n        line-height: 21px;\n        width: unset;\n    }\n    .campaign-baloers__banner-apps {\n        top: 380px;\n        right: 60%;\n    }\n    .campaign-baloers__how-to__intro{\n        height: auto;\n    }\n  \n/*     .campaign-baloers__definitions-baloers{\n        height: auto;\n    }\n    .campaign-baloers__definitions-verified{\n        height: auto;\n    } */\n    .campaign-baloers__howto-apply-steps{\n        margin-left: 0;\n        height: auto;\n    }\n    .campaign-baloers__prizes__table{\n        width: auto;\n    }\n    .campaign-baloers__prizes-measurement{\n        height: auto;\n    }\n\n}\n\n@media only screen and (max-width: 420px) {\n    .campaign-baloers__how-to, .campaign-baloers__prizes, .campaign-baloers__example, \n    .campaign-baloers__definitions, .campaign-baloers__howto-apply, .campaign-baloers__termsandconditions{\n        padding-left: 0;\n        padding-right: 0;\n    }\n    .campaign-baloers__banner-text-intro{\n        font-size: 30px;\n        line-height: 37px;\n        width: unset;\n    }\n    .campaign-baloers__banner-text-prizes{\n        font-size: 40px;\n        line-height: 49px;\n        width: unset;\n    }\n    .campaign-baloers__banner-text-winners{\n        font-size: 25px;\n        line-height: 21px;\n        width: unset;\n    }\n\n    .campaign-baloers__banner-apps {\n        top: 412px;\n        right: 70%;\n    }\n    .campaign-baloers__how-to__intro{\n        height: auto;\n    }\n    .campaign-baloers__how-to__green-message{\n        width: unset;\n        height: auto;\n    }\n\n    .campaign-baloers__definitions-baloers{\n        width: 100%;\n        height: auto;\n    }\n    .campaign-baloers__definitions-verified{\n        width: 100%;\n        height: auto;\n    }\n    .campaign-baloers__howto-apply-steps{\n        margin-left: 0;\n        height: auto;\n    }\n    .campaign-baloers__prizes__table{\n        width: auto;\n    }\n    .campaign-baloers__prizes-measurement{\n        height: auto;\n    }\n    .campaign-baloers__example__table td{\n        padding: 8px 8px;\n    }\n    .campaign-baloers__example__column-header, .campaign-baloers__example__column-lbl, \n    .campaign-baloers__example__column-text{\n        font-size: 12px;\n        line-height: 15px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
